import userAPI from './user.js'
import orderAPI from './order.js'
import * as extend from './base.api.js'
export {userAPI, orderAPI, extend}



// WEBPACK FOOTER //
// ./src/api/index.js